import { dateFormat } from 'src/util/format'

export function date(value) {
  return dateFormat(value, 'YYYY-MM-DD')
}

export function datetime(value) {
  return dateFormat(value, 'YYYY-MM-DD HH:mm:ss')
}

export function monthtime(value) {
  return dateFormat(value, 'MM月DD日 HH:mm:ss')
}

export function minutetime(value) {
  return dateFormat(value, 'MM月DD日 HH:mm')
}

export function currDay(value) {
  const d = new Date(value)
  const date = new Date((d.setHours(0, 0, 0, 0)))
  return dateFormat(date.getTime(), 'YYYY-MM-DD HH:mm:ss')
}

export function endOfDay(value) {
  const d = new Date(value)
  const date = new Date((d.setHours(23, 59, 59, 0)))
  return dateFormat(date.getTime(), 'YYYY-MM-DD HH:mm:ss')
}
